import { render, staticRenderFns } from "./Simple-card.vue?vue&type=template&id=6baceff3&scoped=true&"
import script from "./Simple-card.vue?vue&type=script&lang=js&"
export * from "./Simple-card.vue?vue&type=script&lang=js&"
import style0 from "./Simple-card.vue?vue&type=style&index=0&id=6baceff3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6baceff3",
  null
  
)

export default component.exports